import './ContactPageElementsCss/AskAQuestion.css';
import React, { useState } from "react";
import doctorImg from '../../Assets/contactUsSideImage1.webp';
import AnimatedText from '../../AnimatedText';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { postContactUs } from '../../api/api';

// ✅ Yup validation schema
const validationSchema = Yup.object({
  first_name: Yup.string().trim().required("Name is required"),
  phone_number: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
    .required("Phone number is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  comment: Yup.string()
    .trim()
    .required("Please enter your query")
    .test(
      "word-count",
      "Query must not exceed 150 words",
      value => value ? value.trim().split(/\s+/).length <= 150 : true
    ),
});

export default function AskQuestionSection() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  // ✅ API call
  const fetchPostContactUs = async (values, resetForm) => {
    try {
      setLoading(true);
      setMessage("");

      // map formik values to API payload
      const payload = {
        name: values.first_name,
        mobile_no: values.phone_number,
        email: values.email,
        sms: values.comment,
      };

      const res = await postContactUs(payload);

      // ✅ success condition
      if (res?.data?.status === true) {
        setMessage(res?.data?.message || "Request submitted successfully!");
        setShowPopup(true);
        resetForm(); // reset form only when success
      } else {
        console.log("API returned failure:", res?.data);
      }
    } catch (err) {
      console.error("Error submitting contact form:", err);
    } finally {
      setLoading(false);
    }
  };

  return (

    




    <div className="ask-question-container">
      <div className="ask-img-section">
        <img src={doctorImg} alt="Doctor" />
      </div>

      <div className="ask-form-section">
        <AnimatedText tag="h2" type="words" y={30} className="rb-title">
          Ask a Question
        </AnimatedText>

        <p className="RB-para-text">
          If you have any question, you can contact us, please, fill out the form below
        </p>

        <Formik
          initialValues={{
            first_name: "",
            phone_number: "",
            email: "",
            comment: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            fetchPostContactUs(values, resetForm);
          }}
        >
          {({ isSubmitting }) => (
          <Form autoComplete="off">
  <div className="input-group">
    {/* First Name */}
    <label
      className="contact-input"
      htmlFor="first_name"
      style={{ marginBottom: "0rem" }}
    >
      Enter Your Full Name <span className="required">*</span>
    </label>
    <Field
      id="first_name"
      name="first_name"
      type="text"
      placeholder="Name"
      autoComplete="off"
    />
    <ErrorMessage name="first_name" component="p" className="error" />

    {/* Phone + Email side by side */}
    <div className="breakInput">
      <div className="form-group">
        <label className="contact-input" htmlFor="phone_number">
          Enter Phone Number <span className="required">*</span>
        </label>
        <Field
          id="phone_number"
          name="phone_number"
          type="tel"
          maxLength={10}
          placeholder="Phone"
          autoComplete="off"
          onKeyPress={(e) => {
    // Allow only numbers
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  }}
        />
        <ErrorMessage name="phone_number" component="p" className="error" />
      </div>

      <div className="form-group">
        <label className="contact-input" htmlFor="email">
          Enter Your mail-Id <span className="required">*</span>
        </label>
        <Field
          id="email"
          name="email"
          type="email"
          placeholder="Email"
          autoComplete="off"
        />
        <ErrorMessage name="email" component="p" className="error" />
      </div>
    </div>
  </div>

  {/* Comment / Query */}
  <div className="textarea-group">
    <label className="contact-input" htmlFor="comment">
      Any Message For Us <span className="required">*</span>
    </label>

    <Field name="comment">
      {({ field, form }) => {
        const words = field.value ? field.value.trim().split(/\s+/) : [];
        const wordCount = field.value.trim() === "" ? 0 : words.length;

        return (
          <>
            <textarea
              {...field}
              id="comment"
              rows="2"
              placeholder="Your message here..."
              autoComplete="off"
              onChange={(e) => {
                let wordList = e.target.value.trim().split(/\s+/);

                if (wordList.length > 150) {
                  wordList = wordList.slice(0, 150);
                  e.target.value = wordList.join(" ");
                }

                form.setFieldValue("comment", e.target.value);
              }}
            />
            <p style={{ fontSize: "12px" }}>
              {wordCount}/150 words
            </p>
          </>
        );
      }}
    </Field>
    <ErrorMessage name="comment" component="p" className="error" />
  </div>

  {/* Submit Button */}
  <button
    type="submit"
    className="rbdButton messageSendBtn"
    disabled={isSubmitting || loading}
  >
    <span className="btn-text">
      {loading ? "Submitting..." : "Send Message"}
    </span>
  </button>
</Form>
          )}
        </Formik>

        {/* Popup Modal — only when success */}
        {showPopup && (
          <div className="modal-overlay" onClick={() => setShowPopup(false)}>
            <div className="modal-box" onClick={(e) => e.stopPropagation()}>
              <img src="/rb-logo.png" alt="RB Diagnostics" />
              <p>{message}</p>
              <button
                className="close-btn"
                onClick={() => setShowPopup(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
